import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LibraryRoutingModule } from './library-routing.module';
import { LibraryComponent } from '../library/library.component';
import { TabsModule } from '@app/components/tabs/tabs.module';
import { HeaderModule } from '@app/components/header/header.module';
import { IconsModule } from '@app/components/icons/icons.module';
import { SharedModule } from '@app/shared/shared.module';
import { CarouselModule } from '@app/components/carousel/carousel.module';
import { ContextMenuLibraryComponent } from './context-menu-library/context-menu-library.component';
import { SortListComponent } from './sort-list/sort-list.component';
import { SearchLibraryComponent } from './search-library/search-library.component';
import {ListItemsModule} from "@app/components/list-items/list-items.module";
import {CarouselLibraryComponent} from "@app/app/library/carousel-library/carousel-library.component";
import {ListLibraryComponent} from "@app/app/library/list-library/list-library.component";


@NgModule({
  declarations: [LibraryComponent, CarouselLibraryComponent, ContextMenuLibraryComponent, SortListComponent, SearchLibraryComponent, ListLibraryComponent],
  imports: [
    CommonModule,
    LibraryRoutingModule,
    TabsModule,
    HeaderModule,
    IconsModule,
    SharedModule,
    CarouselModule,
    ListItemsModule,
    CarouselModule
  ]
})
export class LibraryModule { }
